import React, { useRef, useState, useEffect } from 'react';
import styled from "styled-components";
import io from "socket.io-client";
import axios from 'axios';
import myPic2 from "../../assets/profil-pic-cv.jpg";
import { Collapse } from 'reactstrap';
import * as FaIcons from "react-icons/fa";
import styles from "./Chat.module.css"

// const Page = styled.div`
// display: flex;
// // height: 100vh;
// width: 30%;
// align-items: center;
// background-color: #46516e;
// flex-direction: column;
// border-radius: 10px;
// `;
const Container = styled.div`
display: flex;
flex-direction: column;
height: 300px;
max-height: 300px;
overflow: auto;
width: 100%;
border: 1px solid lightgray;
border-radius: 10px;
padding-bottom: 10px;
// margin-top: 25px;
`;

const TextArea = styled.textarea`
width: 98%;
height: 100px;
border-radius: 10px;
margin-top: 10px;
padding-left: 10px;
padding-top: 10px;
font-size: 17px;
background-color: transparent;
border: 1px solid lightgray;
outline: none;
color: lightgray;
letter-spacing: 1px;
line-height: 20px;
::placeholder {
  color: lightgray;
}
`;

const Button = styled.button`
background-color: green;
width: 100%;
border: none;
height: 50px;
border-radius: 10px;
color: #ffffff;
font-size: 20px;
`;

const Form = styled.form`
width: 100%;
`;

const MyRow = styled.div`
width: 100%;
display: flex;
justify-content: flex-end;
margin-top: 10px;
`;

const MyMessage = styled.div`
width: 45%;
background-color: blue;
color: #ffffff;
padding: 10px;
margin-right: 5px;
text-align: center;
border-top-right-radius: 10%;
border-bottom-right-radius: 10%;
`;

const PartnerRow = styled(MyRow)`
justify-content: flex-start;
`;

const PartnerMessage = styled.div`
width: 45%;
background-color: black;
color: #ffff00;
border: 1px solid lightgray;
padding: 10px;
margin-left: 5px;
text-align: center;
border-top-left-radius: 10%;
border-bottom-left-radius: 10%;
`;

const URL_CHAT_RENDER = "https://portfolio-chat-io.onrender.com"; 
const Chat = ({ isAdmin, isOnLine, setIsOnLine, setIsTherMsgs }) => {
    const [yourID, setYourID] = useState();
    const [messages, setMessages] = useState([]);
    const [message, setMessage] = useState("");
    const [msgTime, setMsgTime] = useState();
    const [error, setError] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);
    // to manage dropbox to choice status of disponibility in th switch case
    const [disponibility, setDisponibility] = useState(false)
    // const [indicator, setIndicator] = useState(props.isOnLine);

    const socketRef = useRef();
    const getDateAndTime = (newDate) => {
        let date = newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getDate();
        let hours = newDate.getHours() < 10 ? `0${newDate.getHours()}` : newDate.getHours();
        let minutes = newDate.getMinutes() < 10 ? `0${newDate.getMinutes()}` : newDate.getMinutes();
        let seconds = newDate.getSeconds() < 10 ? `0${newDate.getSeconds()}` : newDate.getSeconds();
        let time = hours + ":" + minutes + ":" + seconds;
        return `${date} at : ${time}`;
    }

    // function useForceUpdate() {
    //     let [value, setState] = useState(true);
    //     return () => setState(!value);
    // }
    // let forceUpdate = useForceUpdate();

    const choosDisponibility = async () => {
        if (isAdmin) {
            setDisponibility(!disponibility)
            let isOnLine = { isOnLine: disponibility }
            // console.log('isOnLineInside chooseDispo is :::::>>>', isOnLine);
            // await axios.put("http://localhost:8000/admin/6246165c126f74b59f392314", isOnLine)
            await axios.put(`${URL_CHAT_RENDER}/admin/6246165c126f74b59f392314`, isOnLine)
                .then(res => {
                    // console.log(res.data);
                    // let {isAdmin, isOnLine} = res.data 
                    setIsOnLine(res.data.isOnLine)
                    // forceUpdate(); 
                })
                .catch(error => {
                    console.log(error)
                })
        }
    }

    // function receivedMessage(message) {
    //     setMessages(oldMsgs => [...oldMsgs, message]);
    //     setIsTherMsgs(true);
    //     // console.log(messages);
    // }
    // console.log(props.isOnLine);
    useEffect(() => {
        // socketRef.current = io.connect('http://localhost:8000');  
        // https://chat-socket-portfolio.herokuapp.com
        socketRef.current = io.connect(`${URL_CHAT_RENDER}`);

        function receivedMessage(message) {
            setMessages(oldMsgs => [...oldMsgs, message]);
            setIsTherMsgs(true);
            // console.log(messages);
        }

        socketRef.current.on("your id", id => {
            setYourID(id);
        })

        socketRef.current.on("time", (time) => {
            time = new Date();
            setMsgTime(getDateAndTime(time));
        })

        socketRef.current.on("message", (message) => {
            // console.log("here", message);
            receivedMessage(message);
            setIsTherMsgs(true);
        });

        socketRef.current.emit('join', { email: 'user1@example.com' });

    }, [setIsTherMsgs]);

    function sendMessage(e) {
        e.preventDefault();
        const messageObject = {
            body: message,
            time: msgTime,
            id: yourID,
        };
        // console.log('messageObject is : ----------', messageObject);
        setMessage("");
        if (message) {
            socketRef.current.emit("send message", messageObject);
        } else {
            setError('veuillez saisir un message')
        }
    }

    function handleChange(e) {
        setError('');
        setMessage(e.target.value);
    }
    // console.log(messages);
    return (
        <div>
            <Collapse className={styles.collapse} isOpen={isOpen}>
                <h5 style={{ color: '#ffffff' }}>En cours d'amélioration...</h5>
                <Container>
                    {messages.map((message, index) => {
                        if (message.id === yourID) {
                            return (
                                <div key={index}>
                                    <MyRow >
                                        <span style={{ color: '#ffffff' }}>Me</span>
                                        <MyMessage>
                                            {message.body}
                                        </MyMessage>
                                    </MyRow>
                                    <div className={styles.messages}>
                                        {message.time}
                                    </div>
                                </div>
                            )
                        }
                        return (
                            <div key={index}>
                                <PartnerRow key={index}>
                                    <img style={{ width: '20px', height: '20px' }} src={myPic2} alt="photoDeOmar-cv" />
                                    <PartnerMessage>
                                        {message.body}
                                    </PartnerMessage>
                                </PartnerRow>
                                <div className={styles.partnerMessages}>
                                    {message.time}
                                </div>
                            </div>
                        )
                    })}
                </Container>
                <Form onSubmit={sendMessage}>
                    <TextArea value={message} onChange={handleChange} placeholder={messages.length === 0 ? "Bonjour, bienvenue, chat..." : "Votre message ici"} />
                    <Button>Send</Button>
                    {error && <p style={{ color: '#ff0000' }}>{error}</p>}
                </Form>
            </Collapse>
            <div style={{ backgroundColor: '#000000', color: '#ffffff', height: '48px', borderRadius: '6px' }} size="sm">
                <div className={styles.divChatCollapseHeader}>
                    <div className={styles.imgIndicator}>
                        <img className={styles.imgChat} src={myPic2} alt="photoDeOmar-cv" />
                        <FaIcons.FaRegCircle onClick={choosDisponibility} className={isOnLine ? styles.indicatorOnLine : styles.indicatorOutLine} />
                    </div>
                    <div onClick={toggle} className='row'>
                        <span style={{ color: '#a9ff00', cursor: 'pointer' }}>Messagerie chat</span>
                        <div className={styles.iconChat} >
                            {isOpen ? <FaIcons.FaArrowDown /> : <FaIcons.FaArrowUp />}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Chat;